<sat-popover
  #popRef
  [horizontalAlign]="horizontalAlign"
  [verticalAlign]="verticalAlign"
  hasBackdrop
  backdropClass="zef-pop-light-backdrop"
  (backdropClicked)="popRef.close(); closeTrigger.emit();">
  <mat-card class="__pop  z-manual-elevation  c-soft-elevation">

    <h3
      class="mat-h3 __heading"
      [innerHTML]="heading">
    </h3>

    <ng-content />

    <div class="__actions-grid">

      <div>
        <button
          mat-raised-button
          [color]="confirmColor"
          type="button"
          class="__button"
          (click)="confirm.emit(); popRef.close();">
          @if (confirmButtonIcon) {
            <mat-icon>{{ confirmButtonIcon }}</mat-icon>
          }
          {{ confirmButtonText }}
        </button>
      </div>

      <div>
        <button
          mat-button
          type="button"
          class="__button"
          (click)="closeTrigger.emit(); popRef.close();">
          {{ closeButtonText }}
        </button>
      </div>

    </div>

  </mat-card>
</sat-popover>
